import { useMemo } from 'react'

import { sameResourceId } from '@krp/client-runtime'
import { platformMyResources, type PlatformMyResourcesArgs } from '@krp/platform-ui'
import { OWN_KIND } from '@krp/resource-own-ui'

import { useAppSelector } from '../../app/hooks'

/**
 * Есть ли у человека право вида «Собственная» на этом ресурсе — по списку «моих ресурсов» с этим правом (`me/resources`),
 * тому же, по которому оболочка строит вкладки разделов. Кнопки записи только ОТРАЖАЮТ его: команду служба проверит сама.
 * Пока ответа нет или он с ошибкой — `false`: запись выключена с причиной, а не открыта наугад.
 */
export function useOwnCapability(resourceId: string, capability: string): boolean {
  const args = useMemo<PlatformMyResourcesArgs>(() => ({ kind: OWN_KIND, capability }), [capability])
  platformMyResources.useQuerySubscription(args, { skip: resourceId === '' })
  const select = useMemo(() => platformMyResources.select(args), [args])
  const query = useAppSelector(select)
  if (query.isError || query.data === undefined) return false
  return query.data.some((resource) => sameResourceId(resource.id, resourceId))
}
